import React, { useState } from 'react';
import './QuoteForm.css';

const QuoteForm = ({ serviceName }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    product_details: serviceName || ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://admin.techieinteriors.co.ke/api/v1/quotation/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to submit quote request');
      }

      const data = await response.json();
      console.log('Quote submitted successfully:', data);
      setSubmitted(true);
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        product_details: serviceName || ''
      });

      // Hide success message after 5 seconds
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      console.error('Error submitting quote:', err);
      setError('Failed to submit quote. Please try again or contact us directly.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="quote-form-wrapper">
      {submitted && (
        <div className="success-message">
          ✓ Your quote request has been submitted successfully! We'll contact you shortly.
        </div>
      )}
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <form className="quote-form" onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input 
              type="text" 
              id="name" 
              name="name" 
              value={formData.name} 
              onChange={handleInputChange} 
              required 
              placeholder="John Doe"
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              value={formData.email} 
              onChange={handleInputChange} 
              required 
              placeholder="john@example.com"
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number *</label>
            <input 
              type="tel" 
              id="phone" 
              name="phone" 
              value={formData.phone} 
              onChange={handleInputChange} 
              required 
              placeholder="+254748600208"
            />
          </div>
          <div className="form-group">
            <label htmlFor="product_details">Service Required *</label>
            <input 
              type="text" 
              id="product_details" 
              name="product_details" 
              value={formData.product_details} 
              onChange={handleInputChange} 
              required 
              placeholder="Service name"
            />
          </div>
        </div>
        <button type="submit" className="submit-quote-button" disabled={loading}>
          {loading ? 'Submitting...' : 'Request Quote'}
        </button>
      </form>
    </div>
  );
};

export default QuoteForm;
